import React from 'react';
import styled from 'styled-components';

const StyledDiv = styled.div`
  position: relative; /* for IE11 */
  position: sticky;
  position: -webkit-sticky;
  top: 0px;
  z-index: 100;
`;

interface Props {
  children: any;
}

export const StickyContent = (props: Props) => {
  const { children } = props;
  return <StyledDiv>{children}</StyledDiv>;
};
